import { Flag, Video } from "lucide-react";
import { NewsTicker, useEventi, useInterviste } from "./NewsTicker";

export const IntervisteTicker = () => {
  const items = useInterviste();
  return (
    <NewsTicker
      testid="interviste-ticker"
      label="Video interviste"
      icon={Video}
      tone="dark"
      duration={50}
      items={items.map((i) => ({ text: i.titolo, href: `/interviste/${i.slug}`, meta: "Legend Magazine" }))}
    />
  );
};

export const GareTicker = () => {
  const eventi = useEventi();
  return (
    <NewsTicker
      testid="gare-ticker"
      label="Ultime gare"
      icon={Flag}
      tone="light"
      duration={35}
      items={eventi.map((e) => ({ text: `${e.titolo}`, href: `/gare/${e.slug}`, meta: e.luogo }))}
    />
  );
};
